import {useCallback, useMemo} from "react";
import {parseISO, startOfToday} from "date-fns";

import {IRangeQuery} from "../../request/IRangeQuery";

export const useConstructionCompletionPercent = () => {
    const today = useMemo(() => startOfToday().getTime(), []);

    const calculateConstructionCompletionPercent = useCallback(
        (constructionEndDate: string | undefined | null, constructionDateRange: IRangeQuery<string> | undefined) => {
            const lower = constructionDateRange?.lower;
            const upper = constructionEndDate || constructionDateRange?.upper;

            if (!lower || !upper) {
                return null;
            }

            const lowerTime = parseISO(lower).getTime();
            const upperTime = parseISO(upper).getTime();

            if (upperTime <= lowerTime) {
                return 100;
            }

            const percent = ((today - lowerTime) / (upperTime - lowerTime)) * 100;

            return Math.min(100, Math.max(0, Math.round(percent)));
        },
        [today]
    );

    return {
        calculateConstructionCompletionPercent
    };
};
import {useCallback, useMemo} from "react";
import {parseISO, startOfToday} from "date-fns";

import {IRangeQuery} from "../../request/IRangeQuery";

export const useConstructionCompletionPercent = () => {
    const today = useMemo(() => startOfToday().getTime(), []);

    const calculateConstructionCompletionPercent = useCallback(
        (constructionEndDate: string | undefined | null, constructionDateRange: IRangeQuery<string> | undefined) => {
            const lower = constructionDateRange?.lower;
            const upper = constructionEndDate || constructionDateRange?.upper;

            if (!lower || !upper) {
                return null;
            }

            const lowerTime = parseISO(lower).getTime();
            const upperTime = parseISO(upper).getTime();

            if (upperTime <= lowerTime) {
                return 100;
            }

            const percent = ((today - lowerTime) / (upperTime - lowerTime)) * 100;

            return Math.min(100, Math.max(0, Math.round(percent)));
        },
        [today]
    );

    return {
        calculateConstructionCompletionPercent
    };
};
